import * as React from "react";
const WorkshopTimeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 13-2-3V5m-9 5a9 9 0 1 0 18.001 0A9 9 0 0 0 1 10Z"
    />
  </svg>
);
export default WorkshopTimeIcon;
